import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M16 5.49922C16 6.08998 15.8824 6.67496 15.6541 7.22072C15.4258 7.76652 15.0908 8.26236 14.669 8.68003L8.49358 14.7974C8.22076 15.0675 7.77852 15.0676 7.50574 14.7974L1.33032 8.68037C0.478602 7.83671 2.36345e-05 6.69233 0 5.49922C8.97453e-09 4.30607 0.478581 3.16175 1.33032 2.31807C2.18206 1.4744 3.33732 1.00034 4.54185 1.00034C5.74635 1.00037 6.90167 1.47442 7.75338 2.31807L7.99966 2.56202L8.24628 2.31807L8.3261 2.2407C8.73056 1.85915 9.20294 1.55464 9.71952 1.34261C10.2706 1.11644 10.8613 1 11.4578 1C12.0543 1.00001 12.6451 1.11645 13.1961 1.34261C13.7471 1.56877 14.2477 1.90024 14.6693 2.31807C15.0912 2.73576 15.4258 3.23154 15.6541 3.77738C15.8824 4.32321 16 4.90839 16 5.49922Z" }, null, -1)
  ]))]))
}
export default { render: render }